import { render, staticRenderFns } from "./CompanyInfoSection.vue?vue&type=template&id=1dcd167c&"
import script from "./CompanyInfoSection.vue?vue&type=script&lang=ts&setup=true&"
export * from "./CompanyInfoSection.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports